<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import { Tooltip } from '@svelte-plugins/tooltips';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import ButtonSecondary from '../../shared/ButtonSecondary.svelte';
    import IconBack from '../../shared/Icons/IconBack.svelte';

    export let isOpen: boolean = false;

    export let photos: string[] = [];
    export let current: number = 0;

    let showCopyToClipboardTooltip: boolean = false;
    let showCopyToClipboardTooltipTimeout: any = null;

    function savePhoto() {
        let img: any = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function() {
            let canvas: any = document.createElement('CANVAS');
            let ctx = canvas.getContext('2d');
            let dataURL;
            canvas.height = this.naturalHeight;
            canvas.width = this.naturalWidth;
            ctx.drawImage(this, 0, 0);
            dataURL = canvas.toDataURL('image/jpeg');
            var a  = document.createElement('a');
            a.href = dataURL;
            a.download = this.src.substr(this.src.lastIndexOf('/')+1);
            a.click();
        };
        img.src = photos[current].replace(/^https?:\/\/(img|mapa)\.targeo\.pl\//, _TARGEO_GLOBALS.url);
    }

    function onClick(evt: any) {
        if (evt.target.classList.contains('modal') || evt.target.classList.contains('prev') || evt.target.classList.contains('next') || evt.target.classList.contains('main')) {
            closeModal();
        }
    }

</script>

{#if isOpen}
    <div role="dialog" class="modal" on:click={onClick}>
        <div class="main">
            <div class="prev">
                {#if current > 0}
                    <IconBack scale=1.5 on:click={() => { current-- }}/>
                {/if}
            </div>
            <img src="{photos[current].replace(/^https?:\/\/(img|mapa)\.targeo\.pl\//, _TARGEO_GLOBALS.url)}" alt="">
            <div class="next">
                {#if current < photos.length -1}
                    <div style="transform: rotate(180deg);">
                        <IconBack scale=1.5 on:click={() => { current++ }}/>
                    </div>
                {/if}
            </div>
        </div>
        <div class="actions">
            <div>
            <ButtonMain
                text={$_('Save')}
                on:click={() => {
                    savePhoto();
                }}
            />
            </div>
            <div>
            {#if navigator.clipboard}
                <Tooltip
                    content={$_('Copied')}
                    position="top"
                    animation="slide"
                    bind:show={showCopyToClipboardTooltip}
                    autoPosition
                    arrow={false}
                    action="prop">
                        <ButtonMain
                            text={$_('Copy URL to clipboard')}
                            on:click={() => {
                                navigator.clipboard.writeText(photos[current]);
                                clearTimeout(showCopyToClipboardTooltipTimeout);
                                showCopyToClipboardTooltip = true;
                                showCopyToClipboardTooltipTimeout = setTimeout(() => showCopyToClipboardTooltip = false, 2500);
                            }}
                        />
                    </Tooltip>
            {/if}
            </div>
            <div>
            <ButtonSecondary
                text={$_('Close')}
                showIcon={false}
                on:click={() => {
                    closeModal();
                }}
            />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 1002;
        width: 100vw;
        height: 100vh;
        z-index: 20001;
        background-color:rgba(0,0,0,180);
    }

    .main {
        display: flex;
        align-items: center;
    }

    .prev, .next {
        width: 40px;
        margin: 0 20px;
        filter: invert(1);
    }

    .modal img {
        max-width: 90vw;
        max-height: 90vh;
        cursor: pointer;
    }

    .actions {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        gap: 10px;
    }
</style>
